const cartDrawer = document.getElementById('mini-cart');

if (cartDrawer) {
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'open'
      ) {
        const isOpen = cartDrawer.hasAttribute('open');
        if (isOpen) {
          setTimeout(()=>{
             if (BSS_B2B) {
              const res = BSS_B2B.storage.productStorage.load();
              if (res) {
                if (res.notExistProductIds?.length || res.productIds?.length || res.variantIds?.size) {
                  BSS_B2B.observer.productSubject.notifyObserver('LazyProduct', 'LoadedLazyProduct', {
                    ...res
                  });
                }
              }
            }
          },1000)
        }
      }
    }
  });

  observer.observe(cartDrawer, {
    attributes: true,
    attributeFilter: ['open'],
  });
}